module.exports = __webpack_public_path__ + "img/info.475ea3da.svg";